/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React from "react";
import { Route, Link } from 'react-router-dom'
import {Layout, Space} from "antd";
import "../App.less"
import logo from "../logo-dark.svg"

const ExternalLayout = ({ component: Component, ...rest }) =>{
    return (
        <Route {...rest} render={props => (
            <Layout style={{minHeight:"100vh"}}>
                <Layout.Header><Link to={'/'}><img style={{maxHeight: '80%'}} src={logo}/></Link></Layout.Header>
                <Layout.Content style={{padding: '50px'}}>
                    <Component {...props} />
                </Layout.Content>
            </Layout>
        )} />
    )
}


export {ExternalLayout}

